import { SessionService } from './SessionService';
import { environment } from './../../environments/environment';
import { DataService } from './data.service';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class HierarchyBackupService extends DataService {

  constructor(http: Http, session: SessionService) {
    super(environment.api.myshiftUrl + '/teams/backup', http, session);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/hierarchy-backup.service.ts